// Full Ship-to dataset: Country -> Region/State -> sub-units (cities/departments/provinces/counties/districts).
// `states` maps each region name to an array of its areas. Dependent dropdowns in Header.jsx read this.
export const COUNTRIES = [
  {
    code: "NG", name: "Nigeria", flag: "🇳🇬",
    states: {
      "Abia": ["Umuahia", "Aba", "Arochukwu", "Ohafia"],
      "Adamawa": ["Yola", "Mubi", "Jimeta", "Numan"],
      "Akwa Ibom": ["Uyo", "Eket", "Ikot Ekpene", "Oron"],
      "Anambra": ["Awka", "Onitsha", "Nnewi", "Ekwulobia"],
      "Bauchi": ["Bauchi", "Azare", "Misau", "Jama'are"],
      "Bayelsa": ["Yenagoa", "Brass", "Sagbama", "Ogbia"],
      "Benue": ["Makurdi", "Gboko", "Otukpo", "Katsina-Ala"],
      "Borno": ["Maiduguri", "Biu", "Bama", "Dikwa"],
      "Cross River": ["Calabar", "Ugep", "Ikom", "Ogoja"],
      "Delta": ["Asaba", "Warri", "Sapele", "Ughelli"],
      "Ebonyi": ["Abakaliki", "Afikpo", "Onueke", "Ishieke"],
      "Edo": ["Benin City", "Auchi", "Ekpoma", "Uromi"],
      "Ekiti": ["Ado-Ekiti", "Ikere", "Ilawe", "Ijero"],
      "Enugu": ["Enugu", "Nsukka", "Oji River", "Awgu"],
      "Gombe": ["Gombe", "Kumo", "Bajoga", "Dukku"],
      "Imo": ["Owerri", "Orlu", "Okigwe", "Mbaise"],
      "Jigawa": ["Dutse", "Hadejia", "Birnin Kudu", "Gumel"],
      "Kaduna": ["Kaduna", "Zaria", "Kafanchan", "Zonkwa"],
      "Kano": ["Kano", "Wudil", "Gaya", "Rano"],
      "Katsina": ["Katsina", "Funtua", "Daura", "Malumfashi"],
      "Kebbi": ["Birnin Kebbi", "Argungu", "Yauri", "Zuru"],
      "Kogi": ["Lokoja", "Okene", "Idah", "Kabba"],
      "Kwara": ["Ilorin", "Offa", "Jebba", "Lafiagi"],
      "Lagos": ["Ikeja", "Lagos Island", "Lekki", "Surulere", "Yaba", "Badagry", "Ikorodu"],
      "Nasarawa": ["Lafia", "Keffi", "Akwanga", "Nasarawa"],
      "Niger": ["Minna", "Bida", "Suleja", "Kontagora"],
      "Ogun": ["Abeokuta", "Ijebu-Ode", "Sagamu", "Ota"],
      "Ondo": ["Akure", "Ondo", "Owo", "Ikare"],
      "Osun": ["Osogbo", "Ile-Ife", "Ilesa", "Ede"],
      "Oyo": ["Ibadan", "Ogbomosho", "Oyo", "Iseyin"],
      "Plateau": ["Jos", "Bukuru", "Pankshin", "Shendam"],
      "Rivers": ["Port Harcourt", "Obio-Akpor", "Bonny", "Degema"],
      "Sokoto": ["Sokoto", "Tambuwal", "Wurno", "Gwadabawa"],
      "Taraba": ["Jalingo", "Wukari", "Bali", "Zing"],
      "Yobe": ["Damaturu", "Potiskum", "Gashua", "Nguru"],
      "Zamfara": ["Gusau", "Kaura Namoda", "Talata Mafara", "Anka"],
      "FCT Abuja": ["Abuja (Municipal)", "Gwagwalada", "Kuje", "Bwari", "Abaji", "Kwali"],
    },
  },
  {
    code: "FR", name: "France", flag: "🇫🇷",
    states: {
      "Auvergne-Rhône-Alpes": ["Ain", "Allier", "Ardèche", "Cantal", "Drôme", "Isère", "Loire", "Haute-Loire", "Puy-de-Dôme", "Rhône", "Savoie", "Haute-Savoie"],
      "Bourgogne-Franche-Comté": ["Côte-d'Or", "Doubs", "Jura", "Nièvre", "Haute-Saône", "Saône-et-Loire", "Yonne", "Territoire de Belfort"],
      "Bretagne": ["Côtes-d'Armor", "Finistère", "Ille-et-Vilaine", "Morbihan"],
      "Centre-Val de Loire": ["Cher", "Eure-et-Loir", "Indre", "Indre-et-Loire", "Loir-et-Cher", "Loiret"],
      "Corse": ["Corse-du-Sud", "Haute-Corse"],
      "Grand Est": ["Ardennes", "Aube", "Marne", "Haute-Marne", "Meurthe-et-Moselle", "Meuse", "Moselle", "Bas-Rhin", "Haut-Rhin", "Vosges"],
      "Hauts-de-France": ["Aisne", "Nord", "Oise", "Pas-de-Calais", "Somme"],
      "Île-de-France": ["Paris", "Seine-et-Marne", "Yvelines", "Essonne", "Hauts-de-Seine", "Seine-Saint-Denis", "Val-de-Marne", "Val-d'Oise"],
      "Normandie": ["Calvados", "Eure", "Manche", "Orne", "Seine-Maritime"],
      "Nouvelle-Aquitaine": ["Charente", "Charente-Maritime", "Corrèze", "Creuse", "Dordogne", "Gironde", "Landes", "Lot-et-Garonne", "Pyrénées-Atlantiques", "Deux-Sèvres", "Vienne", "Haute-Vienne"],
      "Occitanie": ["Ariège", "Aude", "Aveyron", "Gard", "Haute-Garonne", "Gers", "Hérault", "Lot", "Lozère", "Hautes-Pyrénées", "Pyrénées-Orientales", "Tarn", "Tarn-et-Garonne"],
      "Pays de la Loire": ["Loire-Atlantique", "Maine-et-Loire", "Mayenne", "Sarthe", "Vendée"],
      "Provence-Alpes-Côte d'Azur": ["Alpes-de-Haute-Provence", "Hautes-Alpes", "Alpes-Maritimes", "Bouches-du-Rhône", "Var", "Vaucluse"],
    },
  },
  {
    code: "IT", name: "Italy", flag: "🇮🇹",
    states: {
      "Abruzzo": ["L'Aquila", "Chieti", "Pescara", "Teramo"],
      "Basilicata": ["Potenza", "Matera"],
      "Calabria": ["Catanzaro", "Cosenza", "Crotone", "Reggio Calabria", "Vibo Valentia"],
      "Campania": ["Avellino", "Benevento", "Caserta", "Napoli", "Salerno"],
      "Emilia-Romagna": ["Bologna", "Ferrara", "Forlì-Cesena", "Modena", "Parma", "Piacenza", "Ravenna", "Reggio Emilia", "Rimini"],
      "Friuli-Venezia Giulia": ["Gorizia", "Pordenone", "Trieste", "Udine"],
      "Lazio": ["Frosinone", "Latina", "Rieti", "Roma", "Viterbo"],
      "Liguria": ["Genova", "Imperia", "La Spezia", "Savona"],
      "Lombardia": ["Bergamo", "Brescia", "Como", "Cremona", "Lecco", "Lodi", "Mantova", "Milano", "Monza e Brianza", "Pavia", "Sondrio", "Varese"],
      "Marche": ["Ancona", "Ascoli Piceno", "Fermo", "Macerata", "Pesaro e Urbino"],
      "Molise": ["Campobasso", "Isernia"],
      "Piemonte": ["Alessandria", "Asti", "Biella", "Cuneo", "Novara", "Torino", "Verbano-Cusio-Ossola", "Vercelli"],
      "Puglia": ["Bari", "Barletta-Andria-Trani", "Brindisi", "Foggia", "Lecce", "Taranto"],
      "Sardegna": ["Cagliari", "Nuoro", "Oristano", "Sassari", "Sud Sardegna"],
      "Sicilia": ["Agrigento", "Caltanissetta", "Catania", "Enna", "Messina", "Palermo", "Ragusa", "Siracusa", "Trapani"],
      "Toscana": ["Arezzo", "Firenze", "Grosseto", "Livorno", "Lucca", "Massa-Carrara", "Pisa", "Pistoia", "Prato", "Siena"],
      "Trentino-Alto Adige": ["Bolzano", "Trento"],
      "Umbria": ["Perugia", "Terni"],
      "Valle d'Aosta": ["Aosta"],
      "Veneto": ["Belluno", "Padova", "Rovigo", "Treviso", "Venezia", "Verona", "Vicenza"],
    },
  },
  {
    code: "US", name: "United States", flag: "🇺🇸",
    states: {
      "Alabama": ["Birmingham", "Montgomery", "Mobile", "Huntsville"],
      "Alaska": ["Anchorage", "Fairbanks", "Juneau"],
      "Arizona": ["Phoenix", "Tucson", "Mesa", "Scottsdale"],
      "Arkansas": ["Little Rock", "Fayetteville", "Fort Smith"],
      "California": ["Los Angeles", "San Francisco", "San Diego", "Sacramento", "San Jose"],
      "Colorado": ["Denver", "Colorado Springs", "Aurora", "Boulder"],
      "Connecticut": ["Bridgeport", "New Haven", "Hartford", "Stamford"],
      "Delaware": ["Wilmington", "Dover", "Newark"],
      "Florida": ["Miami", "Orlando", "Tampa", "Jacksonville", "Tallahassee"],
      "Georgia": ["Atlanta", "Savannah", "Augusta", "Columbus"],
      "Hawaii": ["Honolulu", "Hilo", "Kailua"],
      "Idaho": ["Boise", "Nampa", "Idaho Falls"],
      "Illinois": ["Chicago", "Aurora", "Springfield", "Naperville"],
      "Indiana": ["Indianapolis", "Fort Wayne", "Evansville", "South Bend"],
      "Iowa": ["Des Moines", "Cedar Rapids", "Davenport"],
      "Kansas": ["Wichita", "Overland Park", "Kansas City", "Topeka"],
      "Kentucky": ["Louisville", "Lexington", "Bowling Green"],
      "Louisiana": ["New Orleans", "Baton Rouge", "Shreveport", "Lafayette"],
      "Maine": ["Portland", "Lewiston", "Bangor", "Augusta"],
      "Maryland": ["Baltimore", "Annapolis", "Frederick", "Rockville"],
      "Massachusetts": ["Boston", "Worcester", "Springfield", "Cambridge"],
      "Michigan": ["Detroit", "Grand Rapids", "Ann Arbor", "Lansing"],
      "Minnesota": ["Minneapolis", "Saint Paul", "Rochester", "Duluth"],
      "Mississippi": ["Jackson", "Gulfport", "Biloxi", "Hattiesburg"],
      "Missouri": ["Kansas City", "St. Louis", "Springfield", "Columbia"],
      "Montana": ["Billings", "Missoula", "Great Falls", "Helena"],
      "Nebraska": ["Omaha", "Lincoln", "Bellevue"],
      "Nevada": ["Las Vegas", "Reno", "Henderson", "Carson City"],
      "New Hampshire": ["Manchester", "Nashua", "Concord"],
      "New Jersey": ["Newark", "Jersey City", "Trenton", "Atlantic City"],
      "New Mexico": ["Albuquerque", "Santa Fe", "Las Cruces"],
      "New York": ["New York City", "Buffalo", "Rochester", "Albany", "Syracuse"],
      "North Carolina": ["Charlotte", "Raleigh", "Greensboro", "Durham"],
      "North Dakota": ["Fargo", "Bismarck", "Grand Forks"],
      "Ohio": ["Columbus", "Cleveland", "Cincinnati", "Toledo"],
      "Oklahoma": ["Oklahoma City", "Tulsa", "Norman"],
      "Oregon": ["Portland", "Salem", "Eugene", "Bend"],
      "Pennsylvania": ["Philadelphia", "Pittsburgh", "Allentown", "Harrisburg"],
      "Rhode Island": ["Providence", "Warwick", "Cranston"],
      "South Carolina": ["Columbia", "Charleston", "Greenville", "Myrtle Beach"],
      "South Dakota": ["Sioux Falls", "Rapid City", "Pierre"],
      "Tennessee": ["Nashville", "Memphis", "Knoxville", "Chattanooga"],
      "Texas": ["Houston", "Dallas", "Austin", "San Antonio", "Fort Worth"],
      "Utah": ["Salt Lake City", "Provo", "West Valley City", "Ogden"],
      "Vermont": ["Burlington", "Montpelier", "Rutland"],
      "Virginia": ["Virginia Beach", "Richmond", "Norfolk", "Arlington"],
      "Washington": ["Seattle", "Spokane", "Tacoma", "Olympia"],
      "West Virginia": ["Charleston", "Huntington", "Morgantown"],
      "Wisconsin": ["Milwaukee", "Madison", "Green Bay", "Kenosha"],
      "Wyoming": ["Cheyenne", "Casper", "Laramie"],
    },
  },
  {
    code: "GB", name: "United Kingdom", flag: "🇬🇧",
    states: {
      "England": ["Greater London", "Greater Manchester", "Merseyside", "West Midlands", "West Yorkshire", "South Yorkshire", "Tyne and Wear", "Kent", "Essex", "Surrey", "Hampshire", "Lancashire", "Devon", "Norfolk", "Suffolk", "Cheshire", "Cornwall", "Cumbria", "Derbyshire", "Dorset", "County Durham", "East Sussex", "West Sussex", "Gloucestershire", "Hertfordshire", "Leicestershire", "Lincolnshire", "Northamptonshire", "Nottinghamshire", "Oxfordshire", "Somerset", "Staffordshire", "Warwickshire", "Wiltshire", "Worcestershire", "Berkshire", "Buckinghamshire", "Cambridgeshire", "Bristol", "Herefordshire", "Rutland", "Shropshire", "Bedfordshire", "Northumberland", "North Yorkshire", "East Riding of Yorkshire", "Isle of Wight"],
      "Scotland": ["Glasgow", "Edinburgh", "Aberdeen", "Dundee", "Fife", "Highland", "Stirling", "Perth and Kinross", "Falkirk", "North Lanarkshire", "South Lanarkshire", "Renfrewshire", "Inverclyde", "West Lothian", "East Lothian", "Midlothian", "Angus", "Argyll and Bute", "Dumfries and Galloway", "Scottish Borders", "Moray", "East Ayrshire", "North Ayrshire", "South Ayrshire", "Clackmannanshire", "East Dunbartonshire", "West Dunbartonshire", "Na h-Eileanan Siar", "Orkney", "Shetland"],
      "Wales": ["Cardiff", "Swansea", "Newport", "Wrexham", "Gwynedd", "Conwy", "Denbighshire", "Flintshire", "Carmarthenshire", "Ceredigion", "Pembrokeshire", "Powys", "Monmouthshire", "Bridgend", "Caerphilly", "Merthyr Tydfil", "Neath Port Talbot", "Rhondda Cynon Taf", "Torfaen", "Blaenau Gwent", "Vale of Glamorgan", "Isle of Anglesey"],
      "Northern Ireland": ["Antrim", "Armagh", "Down", "Fermanagh", "Londonderry", "Tyrone", "Belfast"],
    },
  },
  {
    code: "DE", name: "Germany", flag: "🇩🇪",
    states: {
      "Baden-Württemberg": ["Stuttgart", "Karlsruhe", "Mannheim", "Freiburg", "Heidelberg", "Ulm"],
      "Bavaria": ["Munich", "Nuremberg", "Augsburg", "Regensburg", "Würzburg", "Ingolstadt"],
      "Berlin": ["Berlin"],
      "Brandenburg": ["Potsdam", "Cottbus", "Brandenburg an der Havel", "Frankfurt (Oder)"],
      "Bremen": ["Bremen", "Bremerhaven"],
      "Hamburg": ["Hamburg"],
      "Hesse": ["Frankfurt", "Wiesbaden", "Kassel", "Darmstadt", "Offenbach"],
      "Lower Saxony": ["Hanover", "Braunschweig", "Oldenburg", "Osnabrück", "Göttingen"],
      "Mecklenburg-Vorpommern": ["Rostock", "Schwerin", "Neubrandenburg", "Stralsund"],
      "North Rhine-Westphalia": ["Cologne", "Düsseldorf", "Dortmund", "Essen", "Duisburg", "Bonn"],
      "Rhineland-Palatinate": ["Mainz", "Ludwigshafen", "Koblenz", "Trier", "Kaiserslautern"],
      "Saarland": ["Saarbrücken", "Neunkirchen", "Homburg"],
      "Saxony": ["Dresden", "Leipzig", "Chemnitz", "Zwickau"],
      "Saxony-Anhalt": ["Magdeburg", "Halle", "Dessau-Roßlau"],
      "Schleswig-Holstein": ["Kiel", "Lübeck", "Flensburg", "Neumünster"],
      "Thuringia": ["Erfurt", "Jena", "Gera", "Weimar"],
    },
  },
  {
    code: "ES", name: "Spain", flag: "🇪🇸",
    states: {
      "Andalusia": ["Almería", "Cádiz", "Córdoba", "Granada", "Huelva", "Jaén", "Málaga", "Sevilla"],
      "Aragon": ["Huesca", "Teruel", "Zaragoza"],
      "Asturias": ["Asturias"],
      "Balearic Islands": ["Illes Balears"],
      "Basque Country": ["Álava", "Biscay", "Gipuzkoa"],
      "Canary Islands": ["Las Palmas", "Santa Cruz de Tenerife"],
      "Cantabria": ["Cantabria"],
      "Castile and León": ["Ávila", "Burgos", "León", "Palencia", "Salamanca", "Segovia", "Soria", "Valladolid", "Zamora"],
      "Castilla-La Mancha": ["Albacete", "Ciudad Real", "Cuenca", "Guadalajara", "Toledo"],
      "Catalonia": ["Barcelona", "Girona", "Lleida", "Tarragona"],
      "Extremadura": ["Badajoz", "Cáceres"],
      "Galicia": ["A Coruña", "Lugo", "Ourense", "Pontevedra"],
      "Community of Madrid": ["Madrid"],
      "Region of Murcia": ["Murcia"],
      "Navarre": ["Navarra"],
      "La Rioja": ["La Rioja"],
      "Valencian Community": ["Alicante", "Castellón", "Valencia"],
    },
  },
  {
    code: "CN", name: "China", flag: "🇨🇳",
    states: {
      // 23 Provinces
      "Anhui": ["Hefei", "Wuhu", "Bengbu", "Anqing"],
      "Fujian": ["Fuzhou", "Xiamen", "Quanzhou", "Zhangzhou"],
      "Gansu": ["Lanzhou", "Tianshui", "Baiyin", "Jiuquan"],
      "Guangdong": ["Guangzhou", "Shenzhen", "Dongguan", "Foshan", "Zhuhai"],
      "Guizhou": ["Guiyang", "Zunyi", "Anshun", "Liupanshui"],
      "Hainan": ["Haikou", "Sanya", "Danzhou", "Qionghai"],
      "Hebei": ["Shijiazhuang", "Tangshan", "Baoding", "Handan"],
      "Heilongjiang": ["Harbin", "Daqing", "Qiqihar", "Mudanjiang"],
      "Henan": ["Zhengzhou", "Luoyang", "Kaifeng", "Nanyang"],
      "Hubei": ["Wuhan", "Yichang", "Xiangyang", "Jingzhou"],
      "Hunan": ["Changsha", "Zhuzhou", "Xiangtan", "Hengyang"],
      "Jiangsu": ["Nanjing", "Suzhou", "Wuxi", "Changzhou", "Xuzhou"],
      "Jiangxi": ["Nanchang", "Jiujiang", "Ganzhou", "Shangrao"],
      "Jilin": ["Changchun", "Jilin City", "Siping", "Yanji"],
      "Liaoning": ["Shenyang", "Dalian", "Anshan", "Jinzhou"],
      "Qinghai": ["Xining", "Golmud", "Haidong"],
      "Shaanxi": ["Xi'an", "Baoji", "Xianyang", "Yan'an"],
      "Shandong": ["Jinan", "Qingdao", "Yantai", "Weifang", "Zibo"],
      "Shanxi": ["Taiyuan", "Datong", "Linfen", "Yuncheng"],
      "Sichuan": ["Chengdu", "Mianyang", "Deyang", "Nanchong"],
      "Yunnan": ["Kunming", "Dali", "Lijiang", "Qujing"],
      "Zhejiang": ["Hangzhou", "Ningbo", "Wenzhou", "Shaoxing", "Jiaxing"],
      "Taiwan": ["Taipei", "Kaohsiung", "Taichung", "Tainan"],
      // 5 Autonomous Regions
      "Guangxi": ["Nanning", "Guilin", "Liuzhou", "Beihai"],
      "Inner Mongolia": ["Hohhot", "Baotou", "Ordos", "Chifeng"],
      "Ningxia": ["Yinchuan", "Shizuishan", "Wuzhong"],
      "Tibet": ["Lhasa", "Shigatse", "Nyingchi", "Qamdo"],
      "Xinjiang": ["Ürümqi", "Kashgar", "Korla", "Hotan"],
      // 4 Municipalities
      "Beijing": ["Beijing"],
      "Shanghai": ["Shanghai"],
      "Tianjin": ["Tianjin"],
      "Chongqing": ["Chongqing"],
      // 2 Special Administrative Regions
      "Hong Kong": ["Hong Kong Island", "Kowloon", "New Territories"],
      "Macau": ["Macau Peninsula", "Taipa", "Coloane"],
    },
  },
];
